import { useTheme } from '@mui/material';

export default function NotesIcon() {
  const theme = useTheme();
  return (
    <svg width='32' height='33' viewBox='0 0 32 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='33' fill='#999494' />
      <g id='Call logs'>
        <path
          d='M-299 -2819C-299 -2820.1 -298.105 -2821 -297 -2821H1691C1692.1 -2821 1693 -2820.1 1693 -2819V510C1693 511.105 1692.1 512 1691 512H-297C-298.105 512 -299 511.104 -299 510V-2819Z'
          fill='#444444'
        />
        <path
          d='M-297 -2820H1691V-2822H-297V-2820ZM1692 -2819V510H1694V-2819H1692ZM1691 511H-297V513H1691V511ZM-298 510V-2819H-300V510H-298ZM-297 511C-297.552 511 -298 510.552 -298 510H-300C-300 511.657 -298.657 513 -297 513V511ZM1692 510C1692 510.552 1691.55 511 1691 511V513C1692.66 513 1694 511.657 1694 510H1692ZM1691 -2820C1691.55 -2820 1692 -2819.55 1692 -2819H1694C1694 -2820.66 1692.66 -2822 1691 -2822V-2820ZM-297 -2822C-298.657 -2822 -300 -2820.66 -300 -2819H-298C-298 -2819.55 -297.552 -2820 -297 -2820V-2822Z'
          fill='white'
          fill-opacity='0.1'
        />
        <g id='Call Pop up'>
          <g id='Frame 1000003333'>
            <rect width='1141' height='828.452' transform='translate(-40 -409)' fill='white' />
            <g id='Frame 1000003329'>
              <g id='Frame 1000003330'>
                <rect width='572' height='680.452' transform='translate(-40 -349)' fill='white' />
                <g id='Frame 1000003433'>
                  <rect x='-31.5' y='-56.0469' width='555' height='387' rx='3.5' fill='white' />
                  <rect x='-31.5' y='-56.0469' width='555' height='387' rx='3.5' stroke='#ECECEC' />
                  <g id='Frame 1000003430'>
                    <g id='Frame 1000003431'>
                      <rect x='-15.5' y='-12.0469' width='523' height='57' rx='3.5' fill='white' />
                      <rect x='-15.5' y='-12.0469' width='523' height='57' rx='3.5' stroke='#ECECEC' />
                      <g id='Frame 1000003428'>
                        <g id='Frame 1000003427'>
                          <g id='Frame 1000003426'>
                            <circle id='Ellipse 597' cx='16' cy='16.4531' r='16' fill={theme.palette.primary.main} />
                            <g id='description'>
                              <mask
                                id='mask0_381_3359'
                                style={{ maskType: 'alpha' }}
                                maskUnits='userSpaceOnUse'
                                x='6'
                                y='6'
                                width='20'
                                height='21'
                              >
                                <rect id='Bounding box' x='6' y='6.45312' width='20' height='20' fill='#D9D9D9' />
                              </mask>
                              <g mask='url(#mask0_381_3359)'>
                                <path
                                  id='description_2'
                                  d='M12.875 21.2552H19.125V20.0052H12.875V21.2552ZM12.875 17.9219H19.125V16.6719H12.875V17.9219ZM11.2565 24.3802C10.8355 24.3802 10.4792 24.2344 10.1875 23.9427C9.89583 23.651 9.75 23.2947 9.75 22.8738V10.0533C9.75 9.63236 9.89583 9.27604 10.1875 8.98438C10.4792 8.69271 10.8355 8.54688 11.2565 8.54688H17.875L22.25 12.9219V22.8738C22.25 23.2947 22.1042 23.651 21.8125 23.9427C21.5208 24.2344 21.1645 24.3802 20.7435 24.3802H11.2565ZM17.25 13.5469V9.79688H11.2565C11.1923 9.79688 11.1335 9.82361 11.0802 9.87708C11.0267 9.93042 11 9.98917 11 10.0533V22.8738C11 22.9379 11.0267 22.9967 11.0802 23.05C11.1335 23.1035 11.1923 23.1302 11.2565 23.1302H20.7435C20.8077 23.1302 20.8665 23.1035 20.9198 23.05C20.9733 22.9967 21 22.9379 21 22.8738V13.5469H17.25Z'
                                  fill='white'
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
